import {articleModel, baseModel, userModel} from 'apis/model'
import React from 'react'
import {Link} from 'react-router-dom'
import Translate from "../../../modules/local/Translate";
import {RiNewspaperLine} from "react-icons/ri";
import {formatDate} from "../../../helpers/datetimeHelpers";

export const renderMentionsArticle = (item, index) => {
    const {title, created, owner} = item || {}
    return (
        <Translate>
            {(t) => (
                <div key={index} className="flex flex-col p-2 border border-color-50 rounded-md hover:shadow-items">
                    <Link
                        className="flex items-baseline gap-2 text-sm text-color-000 font-medium no-underline leading-tight"
                        to={articleModel.getLinkToDetail(item)}>
                        <RiNewspaperLine size={14} className="text-color-400"/>
                        <span className="flex-1">{title}</span>
                    </Link>
                    <div className="flex flex-1 gap-1 text-2xs mt-1">
            <span className="font-light text-color-400 italic">
              {t('written by')}
            </span>
                        <Link
                            className="text-primary font-bold flex-1"
                            to={userModel.getLinkToDetail(owner)}>
                            {baseModel.get(owner, 'name')}
                        </Link>
                        <span className="text-color-400 italic">
              {formatDate(created, 'HH:mm - DD/MM/YYYY')}
            </span>
                    </div>
                </div>
            )}
        </Translate>
    )
}
